import { useGet } from "@albertine/api-client";
import { isoToFirebaseTimestamp } from "../../../utils/timestamp.util";
import MemberRating from "./MemberRating";
import "./MemberRatings.css";
import InternalIndicator from "../InternalIndicator";

type Props = {
    catalogId: string;
    showTitle?: boolean;
};

function MemberRatings({ catalogId, showTitle = true }: Props) {
    const { data } = useGet("catalogItemReviews", { param: { id: catalogId } });

    const reviews = data?.reviews;

    return (
        <>
            {reviews && reviews.length > 0 ? (
                <div className="member-ratings">
                    {showTitle && (
                        <div className="member-ratings__title">
                            <div>Member feedback</div> <InternalIndicator />
                        </div>
                    )}

                    {reviews.map((review) => (
                        <div key={review.id} className="member-ratings__items">
                            <MemberRating
                                maxRating={5}
                                userRating={review.bookingRating ?? 0}
                                message={review.bookingFeedback}
                                timestamp={isoToFirebaseTimestamp(
                                    review.bookingFeedbackTimestamp,
                                )}
                                ratingBy={review.memberName}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                "No ratings available"
            )}
        </>
    );
}

export default MemberRatings;
